import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Col, Row } from "react-bootstrap";
import { ILicenceProfile, IFPInstrument } from "../../../api/ILicenceProfile";

import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";

interface EnvironmentalLiabilitiesDetailsProps {
  licenceProfileDetails: ILicenceProfile;
}

const EnvironmentalLiabilitiesDetails = ({
  licenceProfileDetails,
}: EnvironmentalLiabilitiesDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Priority Authorisation for Financial Provision"}
            value={licenceProfileDetails.fpPriority}
          />
          <EpaField
            label={"Agreed CRAMP"}
            value={licenceProfileDetails.cramp}
          />
          <EpaField label={"Agreed ELRA"} value={licenceProfileDetails.elra} />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return (
    <EpaCard
      title={"Environmental Liabilities Details"}
      content={bodyElements}
    />
  );
};

export default EnvironmentalLiabilitiesDetails;
